var rich_content_viewer_default = {
  "fontElementMap": "xbZeX",
  "wrapper": "m-ry3",
  "pluginContainerMobile": "FMwx9",
  "viewer": "GZ2DI",
  "android": "CAjUS",
  "rootedTraversedContent": "QXFFR",
  "atomic": "wpoDY",
  "toolbar": "GBZqY",
  "block": "_2634Z"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
